import { render, staticRenderFns } from "./fbpProcessUnClaimed.vue?vue&type=template&id=01a85e01&scoped=true"
import script from "./fbpProcessUnClaimed.vue?vue&type=script&lang=js"
export * from "./fbpProcessUnClaimed.vue?vue&type=script&lang=js"
import style0 from "./fbpProcessUnClaimed.vue?vue&type=style&index=0&id=01a85e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a85e01",
  null
  
)

export default component.exports